export default "__VITE_PUBLIC_ASSET__2cda4a98__"